import React from "react";
import {Button, Timeline} from "antd";
import moment from "moment";
import "./TrackAndTracePanel.scss";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class TimelineOrderCanceled extends React.Component {
    render() {
      return (
        <Timeline className="track-and-trace-timeline">
          <Timeline.Item dot={<CompletedItemIcon />}>
            <span className="timeline-completed-item"><FormattedMessage id="app.panel.timelineorder.ordersetup"/></span>
            {this.props.order.dateCreated && (
              <div className="timeline-hint-label bp-margin-top-smallest-2">
                <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
                {moment(this.props.order.dateCreated).format("MMM DD, YYYY")}
              </div>
            )}
          </Timeline.Item>
          <Timeline.Item dot={<RedItemIcon />}>
            <span className="timeline-red-item"><FormattedMessage id="app.panel.timelineorder.order.returned"/></span>
              {this.props.order.remarks && (
                  <div className="timeline-hint-label">
                      {this.props.order.remarks}
                  </div>
              )}
          </Timeline.Item>
        </Timeline>
      );
    }
  }

  function CompletedItemIcon() {
    return <div className="timeline-dot-completed" />;
  }
  
  function RedItemIcon() {
    return <div className="timeline-dot-red" />;
  }

  export default withUseIntl(TimelineOrderCanceled);